import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';

import 'rc-slider/assets/index.css';
import './RangeSlider.css';

const RangeSlider = props => (
  <Slider
    {...props}
    className={`range-slider__component ${props.className || ''}`}
  />
);

RangeSlider.propTypes = {
  className: PropTypes.string,
};
RangeSlider.defaultProps = {
  className: '',
};

export default RangeSlider;
